"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorCssValue = void 0;
var getColorCssValue = function (color) {
    if (color.startsWith('#'))
        return color;
    return "var(--color--".concat(color, ")");
};
exports.getColorCssValue = getColorCssValue;
